import { _eventBus } from "../../../../core/events/EventBus";
import { myAccountTree } from "../../../../Orchestrator/ConstantTree";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";

export class LoyaltyProgramDetailInitStep extends StepFlow {
  get stepName() {
    return "LoyaltyProgramDetailInit_Step";
  }

  async onExecute(): Promise<void> {
    console.log("Loyalty Program Detail Page Initialize.....");

    _eventBus.emit({
      eventName: myAccountTree.loyaltyProgram.seeMore,
    });
  }
}

export const LoyaltyProgramDetailStepDeclaration = new StepDefinition({
  stepName: "LoyaltyProgramDetailInit_Step",
  stepClass: LoyaltyProgramDetailInitStep,
});
